export default {
  title: {
    en: 'Activate your account',
  },
  text: {
    en: `In order to access limited edition makeup, 
      you must have an active monthly subscription with standard delivery.`,
  },
  confirmButton: {
    en: 'Unpause',
  },
  cancelButton: {
    en: 'No, I don\'t want to save money and try<br />awesome beauty products',
  },
}
